
export const GET_PERFORMANCE_SCORE_HISTORY_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/GET_PERFORMANCE_SCORE_HISTORY_REQUEST";
export const GET_PERFORMANCE_SCORE_HISTORY_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/GET_PERFORMANCE_SCORE_HISTORY_SUCCESS";
export const GET_PERFORMANCE_SCORE_HISTORY_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/GET_PERFORMANCE_SCORE_HISTORY_FAILURE";
